
import ConfirmDialog from 'ui-kit/src/components/ConfirmDialog';
import MasterBlock from '@/components/MasterBlock';

export default {
    props: {
        collName: String,
        editItem: Object,
        fieldPath: String,
        readonly: Boolean,
        columnDefs: Array,
        noDataLabel: String,
    },

    data() {
        return {
            pagination: {
                rowsPerPage: 10,
            },
        };
    },

    computed: {
        subItems() {
            return $.get(this.editItem, this.fieldPath);
        },
        bodyCellSlots() {
            return _.pickBy(this.$scopedSlots, (_, slot) => slot.startsWith('body-cell-'));
        },
        columns() {
            return [
                ...this.columnDefs.map(([name, sortable, type, fieldFn, cellType, autoWidth, align]) => ({
                    name: type === 'files' ? 'files' : name,
                    xyz: name,
                    label: this.getLabel(name),
                    field: this.getField(name, type, fieldFn, cellType),
                    align: align || 'left',
                    sortable,
                    sort: MasterBlock.methods.getSortFn(name, type, fieldFn, cellType),
                    cellType,
                    autoWidth,
                })),
                ...(this.readonly ? [] : [{ name: 'remove' }]),
            ];
        },
    },

    methods: {
        remove(subItem) {
            this.$q.dialog({
                component: ConfirmDialog,
                title: this.$t(`confirm.remove.title.records`),
                message: this.$t(`confirm.remove.message.records.${this.collName}`),
                okLabel: 'Smazat',
                cancelLabel: 'Storno',
            }).onOk(() => {
                $.removeOne(this.subItems, subItem);
            });
        },
        edit(subItem) {
            this.$emit('edit', subItem);
        },
        getCellPath(row, name) {
            return `${this.fieldPath}[${this.subItems.indexOf(row)}].${name}`;
        },
        getLabel(name) {
            return $.getFieldLabel(this.collName, `${this.fieldPath}.${name}`, ['master', 'long']);
        },
        getField(name, type, fieldFn, cellType) {
            return row => {
                const value = MasterBlock.methods.getRawValue(row, name, fieldFn);
                const path = `${this.fieldPath}.${name}`;
                const getFormattedValue = MasterBlock.methods.getFormattedValue.bind(this);

                if (cellType === 'big-small') {
                    const types = type.includes('|') ? type.split('|') : [type, type];

                    return value.map((v, idx) => getFormattedValue(path, types[idx], row, v) || '-');
                }

                return getFormattedValue(path, type, row, value) || '-';
            };
        },
        fileNameFn(file) {
            return $.getOriginalFilename(file.name);
        },
        fileHasErrorFn() {
            return false;
        },
        canDownloadFileFn() {
            return true;
        },
        downloadFileFn(file) {
            $.downloadFile(file);
        },
        removeFileFn(files, file) {
            if (file.temp) {
                $.removeOne(files, file);
            } else {
                $.set(file, 'removed', true);
            }
        },
    },
};
